// SPDX-License-Identifier: Apache-2.0
enum GeoEvents {
  CustomEventType = 'GeoGirafe.App',
  undoDraw = 'undoDraw',
  zoomToExtent = 'zoomToExtent'
}

export default GeoEvents;
